import { t } from "i18next";
import FormikSelectField from "../../components/HangingProtocol/FormikSelectField";
import FormikATextField from "../../components/HangingProtocol/FormikATextField";
import Condition from "../../components/HangingProtocol/Condition";
import { FormikProvider, Field } from "formik";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "./layout.css";
import { ACTIONS } from "../../constants/Constants";
import { Checkbox, Slider } from "@fluentui/react";
import { useEffect } from "react";
import { color } from "d3";

const Viewport = (props) => {
  const { values, setFieldValue } = props.formik;

  return (
    <FormikProvider value={props.formik}>
      <div>
        {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) && (
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field">
                {/* <Tabs>
                  <TabList>
                    <Tab>{t("hanging-protocol.series-prerequisite")}</Tab>
                  </TabList>
                  <TabPanel>
                    {!Array.isArray(
                      props.allErrors.layout?.viewportList[props.viewportIndex]
                        ?.seriesConditions
                    ) && (
                      <span id="series-prerequisite-errors">
                        <div role="alert">
                          <p className="error-message">
                            <span>
                              {
                                props.allErrors?.layout?.viewportList[
                                  props.viewportIndex
                                ]?.seriesConditions
                              }
                            </span>
                          </p>
                        </div>
                      </span>
                    )}
                    <Condition
                      formik={props.formik}
                      metaTagOptions={props.seriesConditionMetaTagOptions}
                      conditionOperandOptions={props.conditionOperandOptions}
                      name={`layout.viewportList[${props.viewportIndex}].seriesConditions`}
                      conditionList={
                        values.layout.viewportList[props.viewportIndex]
                          .seriesConditions
                      }
                      action={props.action}
                      allErrors={props.allErrors}
                      type={t("hanging-protocol.series-prerequisite")}
                      autoFocus={true}
                    />
                  </TabPanel>
                </Tabs> */}

                <fieldset className="border rounded p-4">
                   <legend className="font-bold">{t("hanging-protocol.series-prerequisite")}</legend>
                  
                  {/* {!Array.isArray(
                    props.allErrors.layout?.viewportList[props.viewportIndex]?.seriesConditions
                  ) && (
                    <span id="series-prerequisite-errors">
                      <div role="alert">
                        <p className="error-message">
                          <span>
                            {props.allErrors?.layout?.viewportList[props.viewportIndex]?.seriesConditions}
                          </span>
                        </p>
                      </div>
                    </span>
                  )} */}

                  <Condition
                    formik={props.formik}
                    metaTagOptions={props.seriesConditionMetaTagOptions}
                    conditionOperandOptions={props.conditionOperandOptions}
                    name={`layout.viewportList[${props.viewportIndex}].seriesConditions`}
                    conditionList={values.layout.viewportList[props.viewportIndex].seriesConditions}
                    action={props.action}
                    allErrors={props.allErrors}
                    type={t("hanging-protocol.series-prerequisite")}
                    autoFocus={true}
                    required={true}
                  />
                </fieldset>

              </div>
            </div>

            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="form-field">
                {/* <Tabs>
                  <TabList>
                    <Tab>{t("hanging-protocol.image-prerequisite")}</Tab>
                  </TabList>
                  <TabPanel>
                    {!Array.isArray(
                      props.allErrors?.layout?.viewportList[props.viewportIndex]
                        ?.imageConditions
                    ) && (
                      <span id="image-prerequisite-errors">
                        <div role="alert">
                          <p className="error-message">
                            <span>
                              {
                                props.allErrors?.layout?.viewportList[
                                  props.viewportIndex
                                ]?.imageConditions
                              }
                            </span>
                          </p>
                        </div>
                      </span>
                    )}
                    <Condition
                      formik={props.formik}
                      metaTagOptions={props.imageConditionMetaTagOptions}
                      conditionOperandOptions={props.conditionOperandOptions}
                      name={`layout.viewportList[${props.viewportIndex}].imageConditions`}
                      conditionList={
                        values.layout.viewportList[props.viewportIndex]
                          .imageConditions
                      }
                      action={props.action}
                      allErrors={props.allErrors}
                      type={t("hanging-protocol.image-prerequisite")}
                    />
                  </TabPanel>
                </Tabs> */}

                <fieldset className="border rounded p-4">
                 <legend className="font-bold">{t("hanging-protocol.image-prerequisite")}</legend>
                  {/*
                  {!Array.isArray(
                    props.allErrors?.layout?.viewportList[props.viewportIndex]?.imageConditions
                  ) && (
                    <span id="image-prerequisite-errors">
                      <div role="alert">
                        <p className="error-message">
                          <span>
                            {props.allErrors?.layout?.viewportList[props.viewportIndex]?.imageConditions}
                          </span>
                        </p>
                      </div>
                    </span>
                  )} */}

                  <Condition
                    formik={props.formik}
                    metaTagOptions={props.imageConditionMetaTagOptions}
                    conditionOperandOptions={props.conditionOperandOptions}
                    name={`layout.viewportList[${props.viewportIndex}].imageConditions`}
                    conditionList={values.layout.viewportList[props.viewportIndex].imageConditions}
                    action={props.action}
                    allErrors={props.allErrors}
                    type={t("hanging-protocol.image-prerequisite")}
                  />
                </fieldset>

              </div>
            </div>
            
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <div className="form-field">        
            <fieldset className="border rounded p-4">
              <legend className="font-bold">{t("hanging-protocol.configurations")}</legend>

              <div
                className="ms-Grid-row"
                style={{ marginTop: "20px", display: "flex", flexWrap: "wrap" }}
              >
                <div
                  className="ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2"
                  style={{ marginRight: "40px" }}
                >
                  <Field
                    name={`layout.viewportList[${props.viewportIndex}].windowWidth`}
                    value={
                      values.layout.viewportList[props.viewportIndex].windowWidth
                    }
                    placeholder={t("hanging-protocol.window-width")}
                    label={t("hanging-protocol.window-width")}
                    parentClassName="form-field"
                    component={FormikATextField}
                    allErrors={props.allErrors}
                  />
                </div>
                <div
                  className="ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2"
                  style={{ marginRight: "40px" }}
                >
                  <Field
                    name={`layout.viewportList[${props.viewportIndex}].windowLevel`}
                    value={
                      values.layout.viewportList[props.viewportIndex].windowLevel
                    }
                    placeholder={t("hanging-protocol.window-level")}
                    label={t("hanging-protocol.window-level")}
                    parentClassName="form-field"
                    component={FormikATextField}
                    allErrors={props.allErrors}
                  />
                </div>
                {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}> */}
                <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2">
                  <label className="ms-Label custom-label">
                    {t("hanging-protocol.alignment")}
                  </label>
                  <Field
                    name={`layout.viewportList[${props.viewportIndex}].alignment`}
                    options={props.viewportAlignmentOptions}
                    value={
                      values.layout.viewportList[props.viewportIndex].alignment
                    }
                    component={FormikSelectField}
                    allErrors={props.allErrors}
                  />
                </div>
              </div>

              <div className="ms-Grid-row" style={{ marginTop: "20px", display: "flex", flexWrap: "wrap" }}>
                <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2" style={{ marginRight: "40px", display: "flex", alignItems: "center" }}>
                  <div className="form-field">
                    <Checkbox
                      name={`layout.viewportList[${props.viewportIndex}].flipHorizontally`}
                      label={t("hanging-protocol.horizontal-flip")}
                      checked={
                        values.layout.viewportList[props.viewportIndex]
                          .flipHorizontally === "enable"
                      }
                      onChange={(e, checked) => {
                        setFieldValue(
                          `layout.viewportList[${props.viewportIndex}].flipHorizontally`,
                          checked ? "enable" : "disable"
                        );

                        setFieldValue(
                          `layout.viewportList[${props.viewportIndex}].flipHorizontallyValue`,
                          checked ? "Enable" : "Disable"
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2" style={{ marginRight: "40px", display: "flex", alignItems: "center" }}>
                  <div className="form-field">
                    <Checkbox
                      name={`layout.viewportList[${props.viewportIndex}].flipVertically`}
                      label={t("hanging-protocol.vertical-flip")}
                      style={{
                        color: "white",
                      }}
                      checked={
                        values.layout.viewportList[props.viewportIndex]
                          .flipVertically === "enable"
                      }
                      onChange={(e, checked) => {
                        setFieldValue(
                          `layout.viewportList[${props.viewportIndex}].flipVertically`,
                          checked ? "enable" : "disable"
                        );

                        setFieldValue(
                          `layout.viewportList[${props.viewportIndex}].flipVerticallyValue`,
                          checked ? "Enable" : "Disable"
                        );
                      }}
                    />
                  </div>
                </div>

                {/* </div> */}

                {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}> */}
                <Field
                  name={`layout.viewportList[${props.viewportIndex}].rotation`}
                  value={values.layout.viewportList[props.viewportIndex].rotation}
                  placeholder={t("hanging-protocol.rotation")}
                  label={t("hanging-protocol.rotation-label")}
                  parentClassName={
                    "form-field ms-Grid-col ms-sm6 ms-md6 ms-lg2 ms-xl2"
                  }
                  component={FormikATextField}
                  allErrors={props.allErrors}
                />
                {/* <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                  <Slider
                    name={`layout.viewportList[${props.viewportIndex}].rotation`}
                    label={t("hanging-protocol.rotation")}
                    min={0}
                    max={360}
                    step={1}
                    value={
                      values.layout.viewportList[props.viewportIndex]?.rotation ||
                      0
                    }
                    onChange={(value) =>
                      setFieldValue(
                        `layout.viewportList[${props.viewportIndex}].rotation`,
                        value
                      )
                    }
                    showValue
                  />
                </div> */}
              </div>
            </fieldset>
            </div>
           </div> 

          </div>
        )}
        {props.action === ACTIONS.VIEW && (
          <div className="ms-Grid" dir="ltr">
            {values.layout.viewportList[props.viewportIndex].seriesConditions
              .length > 0 && (
              <div className="ms-Grid-row" style={{ marginTop: "5px" }}>
                {/* <Tabs>
                  <TabList>
                    <Tab>{t("hanging-protocol.series-prerequisite")}</Tab>
                  </TabList>
                  <TabPanel>
                    <Condition
                      formik={props.formik}
                      name={`layout.viewportList[${props.viewportIndex}].seriesConditions`}
                      conditionList={
                        values.layout.viewportList[props.viewportIndex]
                          .seriesConditions
                      }
                      action={props.action}
                    />
                  </TabPanel>
                </Tabs> */}
                <fieldset className="fieldset-container">
                  <legend className="fieldset-legend">{t("hanging-protocol.series-prerequisite")}</legend>
                  <Condition
                    formik={props.formik}
                    name={`layout.viewportList[${props.viewportIndex}].seriesConditions`}
                    conditionList={values.layout.viewportList[props.viewportIndex].seriesConditions}
                    action={props.action}
                  />
                </fieldset>
              </div>
            )}
            {values.layout.viewportList[props.viewportIndex].imageConditions
              .length > 0 && (
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                {/* <Tabs>
                  <TabList>
                    <Tab>{t("hanging-protocol.image-prerequisite")}</Tab>
                  </TabList>
                  <TabPanel>
                    <Condition
                      formik={props.formik}
                      name={`layout.viewportList[${props.viewportIndex}].imageConditions`}
                      conditionList={
                        values.layout.viewportList[props.viewportIndex]
                          .imageConditions
                      }
                      action={props.action}
                    />
                  </TabPanel>
                </Tabs> */}
                <fieldset className="fieldset-container">
                  <legend className="fieldset-legend">{t("hanging-protocol.image-prerequisite")}</legend>
                  <Condition
                    formik={props.formik}
                    name={`layout.viewportList[${props.viewportIndex}].imageConditions`}
                    conditionList={values.layout.viewportList[props.viewportIndex].imageConditions}
                    action={props.action}
                  />
                </fieldset>
              </div>
            )}

          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
            <fieldset className="fieldset-container">
              <legend className="fieldset-legend">{t("hanging-protocol.configurations")}</legend>

                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="form-field ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.window-width")}
                    </div>
                    <div className="form-mt-10">
                    {values.layout.viewportList?.[props.viewportIndex]?.windowWidth || "-"}
                    </div>
                  </div>

                  <div className="form-field ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.window-level")}
                    </div>
                    <div className="form-mt-10">
                      {values.layout.viewportList[props.viewportIndex].windowLevel || "-"}
                    </div>
                  </div>

                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.alignment")}
                    </div>
                    <div className="form-mt-10">
                      {
                        values.layout.viewportList[props.viewportIndex]
                          .alignmentValue
                      }
                    </div>
                  </div>
                </div>

                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.horizontal-flip")}
                    </div>
                    <div className="form-mt-10">
                      {
                        values.layout.viewportList[props.viewportIndex]
                          .flipHorizontallyValue
                      }
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.vertical-flip")}
                    </div>
                    <div className="form-mt-10">
                      {
                        values.layout.viewportList[props.viewportIndex]
                          .flipVerticallyValue
                      }
                    </div>
                  </div>

                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.rotation-label")}
                    </div>
                    <div className="form-mt-10">
                      {values.layout.viewportList[props.viewportIndex].rotation}&deg;
                    </div>
                  </div>
                </div>

                {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.alignment")}
                    </div>
                    <div className="form-mt-10">
                      {
                        values.layout.viewportList[props.viewportIndex]
                          .alignmentValue
                      }
                    </div>
                  </div>
                </div> */}

                {/* <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                  <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hanging-protocol.rotation")}
                    </div>
                    <div className="form-mt-10">
                      {values.layout.viewportList[props.viewportIndex].rotation}
                    </div>
                  </div>
                </div> */}

              </fieldset>
            </div>
          </div>
        )}
      </div>
    </FormikProvider>
  );
};

export default Viewport;
